import { render, staticRenderFns } from "./role_tree_table.vue?vue&type=template&id=c663532e&scoped=true&"
import script from "./role_tree_table.vue?vue&type=script&lang=js&"
export * from "./role_tree_table.vue?vue&type=script&lang=js&"
import style0 from "./role_tree_table.vue?vue&type=style&index=0&id=c663532e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c663532e",
  null
  
)

export default component.exports